<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-time-picker v-model:checked="formData[widget.name]" :disabledHours="widget.options.disabledHours"
            :disabledMinutes="widget.options.disabledMinutes" :disabledSeconds="widget.options.disabledSeconds"
            :disabled="widget.options.disabled" :format="widget.options.format" :placeholder="widget.options.placeholder"
            :inputReadOnly="widget.options.inputReadOnly" :allowClear="widget.options.allowClear" @change="handleOnChange">
        </a-time-picker>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
} = useEvent(widget.value, itemref, formData.value);
</script>